module.exports = __webpack_public_path__ + "img/con3.def512df.png";